import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllActiveExperiences = createAsyncThunk(
  "Experience/ExperiencesListForWebsite",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Experience/ExperiencesListForWebsite`,
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching Experiences:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getExperienceByURL = createAsyncThunk(
  "Experience/FindByURLExperience",
  async (URL: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Experience/FindByURLExperience`,
        { URL },
      );
      return response.data?.Data;
    } catch (error: unknown) {
      const err = error as { response?: { data?: { Details?: string } } };
      console.error("Error Fetching Experience:", error);
      return Promise.reject({
        message: err?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── Server-side fetch functions ─────────────────────────────────────────────

export async function fetchAllActiveExperiences() {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/Experience/ExperiencesListForWebsite`,
      { next: { revalidate: 30 } },
    );
    const json = await res.json();
    return json.Data ?? [];
  } catch {
    return [];
  }
}

export async function fetchExperienceByURL(URL: string) {
  try {
    const res = await fetch(
      `${API_PORTAL_URL}/Experience/FindByURLExperience`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ URL }),
        next: { revalidate: 30 },
      },
    );
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}
